const colNameAndPageIndex = {
  firstRejectionRemark: {
    name: "驳回原因",
    pageIndex: 1
  },
  firstTypeList: {
    name: "企业类型",
    pageIndex: 1
  },
  companyName: {
    name: "企业名称",
    pageIndex: 1
  },
  registeredAddress: {
    name: "注册地址",
    pageIndex: 1
  },
  registeredPostCode: {
    name: "注册地址邮编",
    pageIndex: 1
  },
  mailingAddress: {
    name: "通讯地址",
    pageIndex: 1
  },
  mailingPostCode: {
    name: "通讯地址邮编",
    pageIndex: 1
  },
  companyUrl: {
    name: "企业网址",
    pageIndex: 1
  },
  fax: {
    name: "传真",
    pageIndex: 1
  },
  legalPerson: {
    name: "法人代表",
    pageIndex: 1
  },
  legalPhone: {
    name: "联系电话",
    pageIndex: 1
  },
  legalCard: {
    name: "身份证号",
    pageIndex: 1
  },
  contact: {
    name: "联系人",
    pageIndex: 1
  },
  contactPhone: {
    name: "联系电话",
    pageIndex: 1
  },
  contactEmail: {
    name: "电子邮箱",
    pageIndex: 1
  },
  registeredMoney: {
    name: "注册资金",
    pageIndex: 1
  },
  registeredMoneyOut: {
    name: "其中外资",
    pageIndex: 1
  },
  companyNature: {
    name: "企业性质",
    pageIndex: 1
  },
  companyNatureRemark: {
    name: "其他企业性质",
    pageIndex: 1
  },
  companyForm: {
    name: "企业形式",
    pageIndex: 1
  },
  companyFormRemark: {
    name: "其他企业形式",
    pageIndex: 1
  },
  engageBusinessList: {
    name: "从事业务",
    pageIndex: 1
  },
  engageBusinessRemark: {
    name: "其他具体业务",
    pageIndex: 1
  },
  jointDelivery: {
    name: "共同配送业务",
    pageIndex: 1
  },
  jointDeliveryTotal: {
    name: "年业务总量",
    pageIndex: 1
  },
  assetsTotal: {
    name: "前一年资产总额",
    pageIndex: 1
  },
  assetsTotalTwo: {
    name: "今年资产总额",
    pageIndex: 1
  },
  assureTotal: {
    name: "前一年营业收入",
    pageIndex: 1
  },
  assureTotalTwo: {
    name: "今年营业收入",
    pageIndex: 1
  },
  vatAndIncomeTax: {
    name: "前一年增值税及所得税",
    pageIndex: 1
  },
  vatAndIncomeTaxTwo: {
    name: "今年增值税及所得税",
    pageIndex: 1
  },
  assureDateStart: {
    name: "经营开始时间",
    pageIndex: 1
  },
  assureDateEnd: {
    name: "经营结束时间",
    pageIndex: 1
  },
  serviceNum: {
    name: "服务网点数",
    pageIndex: 1
  },
  clientNum: {
    name: "客户数量",
    pageIndex: 1
  },
  averageDailyDelivery: {
    name: "日均配送量",
    pageIndex: 1
  },
  vehicleMileage: {
    name: "车辆月平均里程",
    pageIndex: 1
  },
  industryHonor: {
    name: "获得行业荣誉、资质或认证",
    pageIndex: 1
  },
  activeProject: {
    name: "参与大型活动项目及服务内容",
    pageIndex: 1
  },
  governmentCite: {
    name: "获得政府嘉奖及表彰",
    pageIndex: 1
  },
  personCharge: {
    name: "主要负责人担任社会职务或社团职务情况",
    pageIndex: 1
  },
  coldVehicleSelfNum: {
    name: "自用车辆数",
    pageIndex: 1
  },
  coldCooperationVehicleNum: {
    name: "合作车辆数",
    pageIndex: 1
  },
  energyVehicle: {
    name: "新能源车辆占比",
    pageIndex: 1
  },
  conformRoadRegulation: {
    name: "符合《道路机动车辆生产企业及产品公告》规定（%）",
    pageIndex: 1
  },
  coldCarMark: {
    name: "冷配车统一标识",
    pageIndex: 1
  },
  coldCarNum: {
    name: "冷配车数",
    pageIndex: 1
  },
  vehicleMonitor: {
    name: "车辆监控系统",
    pageIndex: 1
  },
  logisticsInfoSystemServe: {
    name: "物流信息系统服务商",
    pageIndex: 1
  },
  lastYearColdCard: {
    name: "上一年度获得冷配证",
    pageIndex: 1
  },
  lastYearColdCardNum: {
    name: "获得冷配证数量",
    pageIndex: 1
  },
  coldStorageSelfVolume: {
    name: "自建容量",
    pageIndex: 1
  },
  coldStorageSelfDate: {
    name: "自建时间",
    pageIndex: 1
  },
  coldStorageLeaseVolume: {
    name: "租赁容量",
    pageIndex: 1
  },
  coldStorageLeaseDate: {
    name: "协议租赁时间",
    pageIndex: 1
  },
  storageInfoServe: {
    name: "仓储信息系统服务商",
    pageIndex: 1
  },
  manageSystem: {
    name: "有健全的财务、车辆、证照、安全等方面的管理制度",
    pageIndex: 1
  },
  safeEducation: {
    name: "上一年度获得冷有相关安全生产方面配证",
    pageIndex: 1
  },
  assureGuarantee: {
    name: "有针对运营方面的培训和改善记录等",
    pageIndex: 1
  },
  emergencyPlan: {
    name: "有完备的应急预案、演练、记录等",
    pageIndex: 1
  },
  // 第二页
  "pageTwofileList.photo10": {
    name: "营业执照",
    pageIndex: 2
  },
  "pageTwofileList.photo11": {
    name: "道路运输许可证",
    pageIndex: 2
  },
  "pageTwofileList.photo12": {
    name: "食品生产许可证",
    pageIndex: 2
  },
  "imageListMap[20][0].url": {
    name: "企业简介",
    pageIndex: 2
  },
  "imageListMap[21][0].url": {
    name: "企业征信记录",
    pageIndex: 2
  },
  "imageListMap[31][0].url": {
    name: "与主要客户签订的服务合同",
    pageIndex: 2
  },
  "imageListMap[32][0].url": {
    name: "服务网点及线路清单",
    pageIndex: 2
  },
  "imageListMap[40][0].url": {
    name: "经注册会计事务所审计的本企业上年度财务审计报告",
    pageIndex: 2
  },
  "imageListMap[50][0].url": {
    name: "企业上年度纳税证明",
    pageIndex: 2
  },

  "imageListMap[60][0].url": {
    name:
      "企业管理制度清单及制度内容，包括车辆管理制度、车辆证照管理制度、安全生产管理制度、应急服务措施、服务操作规程等",
    pageIndex: 2
  },
  "imageListMap[70][0].url": {
    name: "上传《冷藏车通行预约登记冷链物流类企业申请表》",
    pageIndex: 2
  },
  "imageListMap[90][0].url": {
    name: "企业承诺书",
    pageIndex: 2
  },
  "imageListMap[113][0].url": {
    name: "租赁冷库合同",
    pageIndex: 3
  },
  "imageListMap[222][0].url": {
    name:
      "请提供机动车登记证书及《机动车行驶证》的主、副页的正、反面，或冷藏车购置合同及发票",
    pageIndex: 3
  },
  coldStorageTypeList: {
    name: "冷库类型",
    pageIndex: 3
  },
  coldStorageSelfList: {
    name: "冷库信息",
    pageIndex: 3
  },
  coldVehicleDetailList: {
    name: "冷藏车信息",
    pageIndex: 3
  }
};
const aduitColNameAndPageIndex = {
  firstRejectionRemark: {
    name: "表单数据",
    pageIndex: 1
  },
  coldVehicleRejectionRemark: {
    name: "企业类型",
    pageIndex: 3
  },
  coldStorageRejectionRemark: {
    name: "冷库信息",
    pageIndex: 3
  },
  // 第二页
  "companyBaseInfoMap[10].rejectionRemark": {
    name: "企业证件信息上传",
    pageIndex: 2
  },
  "companyBaseInfoMap[20].rejectionRemark": {
    name: "企业简介、征信记录上传",
    pageIndex: 2
  },
  "companyBaseInfoMap[30].rejectionRemark": {
    name: "企业与主要客户签订的服务合同、服务网点及路线清单",
    pageIndex: 2
  },
  "companyBaseInfoMap[40].rejectionRemark": {
    name: "经注册会计事务所审计的本企业上年度财务审计报告",
    pageIndex: 2
  },
  "companyBaseInfoMap[50].rejectionRemark": {
    name: "企业上年度纳税证明",
    pageIndex: 2
  },
  "companyBaseInfoMap[60].rejectionRemark": {
    name:
      "企业管理制度清单及制度内容，包括车辆管理制度、车辆证照管理制度、安全生产管理制度、应急服务措施、服务操作规程等",
    pageIndex: 2
  },
  "companyBaseInfoMap[70].rejectionRemark": {
    name: "上传《冷藏车通行预约登记冷链物流类企业申请表》",
    pageIndex: 2
  },
  "companyBaseInfoMap[80].rejectionRemark": {
    name: "主要获奖证书等荣誉证明",
    pageIndex: 2
  },
  "companyBaseInfoMap[90].rejectionRemark": {
    name: "企业承诺书",
    pageIndex: 2
  }
};
export { colNameAndPageIndex, aduitColNameAndPageIndex };
